"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./LabelledItem.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _HeaderItem = _interopRequireDefault(require("../../mixins/HeaderItem"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TrackedLink = _interopRequireDefault(require("../TrackedLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LabelledItem = /*#__PURE__*/function (_React$Component) {
  _inherits(LabelledItem, _React$Component);

  var _super = _createSuper(LabelledItem);

  function LabelledItem() {
    _classCallCheck(this, LabelledItem);

    return _super.apply(this, arguments);
  }

  _createClass(LabelledItem, [{
    key: "render",
    value: function render() {
      var props = {
        className: (0, _classnames.default)("label-link", this.props.className, {
          "has-icon": this.props.icon
        }),
        href: this.props.url,
        onClick: this.handleClick
      };
      var element = this.props.eventLabel ? _TrackedLink.default : "a";

      if (this.props.eventLabel) {
        props.eventLabel = this.props.eventLabel;
      }

      if (this.props.url && this.props.newTab) {
        props.target = "_blank";
        props.rel = "noopener noreferrer";
      }

      return /*#__PURE__*/_react.default.createElement(element, props, [this.props.icon && /*#__PURE__*/_react.default.createElement("i", {
        key: "icon",
        className: this.props.icon
      }), /*#__PURE__*/_react.default.createElement("span", {
        key: "label",
        className: "header-label"
      }, this.props.label)]);
    }
  }]);

  return LabelledItem;
}(_react.default.Component);

_defineProperty(LabelledItem, "propTypes", {
  label: _propTypes.default.object.isRequired,
  icon: _propTypes.default.string,
  url: _propTypes.default.string,
  className: _propTypes.default.string,
  eventLabel: _propTypes.default.string,
  newTab: _propTypes.default.bool
});

var _default = (0, _HeaderItem.default)(LabelledItem, "labelled-item");

exports.default = _default;